import React, { useState } from "react";
import "../styles/App.css";

function Navbar() {
//   const [themeColor, setThemeColor] = useState("#00aaff"); // Default theme color
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const changeTheme = () => {
    const colors = ["#00aaff", "#ff5733", "#28a745", "#ffcc00", "#6f42c1"]; // Theme color options
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    // setThemeColor(randomColor);
    document.documentElement.style.setProperty("--primary-color", randomColor);
  };

  return (
    <nav className="navbar" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", borderRadius: "50px", marginTop: "10px"}}>
      <h2 className="logo">Portfolio</h2>

      {/* Hamburger Menu Icon */}
      <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation Links */}
      <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#contact" >Contact</a></li>
        <li>
          <div onClick={changeTheme} style={{ cursor: "pointer" }}>
           Change Theme
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;